import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { CohortsByProductIdResponseDto } from '@hub-la/sdk-bff-product'
import { inject } from 'inversify'
import { ListCohortsInput } from '../domain/dtos/list-cohorts.dto'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class ListCohorts {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(
    input?: ListCohortsInput,
    signal?: AbortSignal,
  ): Promise<CohortsByProductIdResponseDto['items']> {
    const response = await this.httpClient.request({
      method: HttpMethod.GET,
      url: `${Envs.BFF_PRODUCT_URL}/products/${input?.productId}/cohorts`,
      params: {
        page: input?.page ?? 1,
        pageSize: input?.pageSize ?? 100,
      },
      signal,
    })

    if ([HttpStatusCode.OK, HttpStatusCode.CREATED].includes(response.statusCode)) {
      return response.data?.items
    }

    throw new GeneralError()
  }
}
